export enum CareerApplicationState {
	Processed = "Processed",
	NotProcessed = "NotProcessed",
	New = "New",
}
